import { useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router';

export function useTabParam<T extends string>(
  paramName: string,
  defaultValue: T
): [T, (newValue: T) => void] {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentValue = (searchParams.get(paramName) as T) || defaultValue;

  useEffect(() => {
    if (!searchParams.has(paramName)) {
      setSearchParams(
        (prev) => {
          prev.set(paramName, defaultValue);
          return prev;
        },
        { replace: true }
      );
    }
  }, [searchParams, setSearchParams, paramName, defaultValue]);

  const setValue = useCallback(
    (newValue: T) => {
      setSearchParams(
        (prev) => {
          prev.set(paramName, newValue);
          return prev;
        },
        { replace: true }
      );
    },
    [setSearchParams, paramName]
  );

  return [currentValue, setValue];
}
